import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
@Injectable()
export class ValidateService {
  private formKeys: string[] = [];
  private formFlags = [];
  public validStatus: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(true);
  constructor() {}

  registerForm(keys: string[]) {
    this.formKeys = [];
    this.formKeys = keys;
    this.prepareFormFlags();
  }

  // add key -- new for dynamic feilds

  addInputKey(key: string) {
    this.formKeys.push(key);
    this.formFlags[key] = false;
  }
  // remove key -- new for dynamic feilds
  removeInputKey(key: string) {
    this.formKeys = this.formKeys.filter(item => item !== key);
    delete this.formFlags[key];
    this.checkValidation();
  }

  private prepareFormFlags() {
    this.formFlags = [];
    for (const key of this.formKeys) {
      this.formFlags[key] = false;
    }
  }
  updateFormFlag(key: string, value: boolean) {
    this.formFlags[key] = value;
    this.checkValidation();
  }
  private checkValidation() {
    let status = true;
    for (const key of this.formKeys) {
      if (this.formFlags[key] === false) {
        status = false;
        break;
      }
    }
    this.validStatus.next(status);
    // console.log(this.formFlags);
  }
}
